export const SET_MODULES_CLE_LOADING = "SET_MODULES_CLE_LOADING";
export const SET_MODULES_CLE_ERROR = "SET_MODULES_CLE_ERROR";

export const FETCH_MODULES_CLE_REQUEST = "FETCH_MODULES_CLE_REQUEST";
export const FETCH_MODULES_CLE_SUCCESS = "FETCH_MODULES_CLE_SUCCESS";
export const FETCH_MODULES_CLE_FAIL = "FETCH_MODULES_CLE_FAIL";

export const CREATE_MODULE_CLE_REQUEST = "CREATE_MODULE_CLE_REQUEST";
export const CREATE_MODULE_CLE_SUCCESS = "CREATE_MODULE_CLE_SUCCESS";
export const CREATE_MODULE_CLE_FAIL = "CREATE_MODULE_CLE_FAIL";

export const UPDATE_MODULE_CLE_REQUEST = "UPDATE_MODULE_CLE_REQUEST";
export const UPDATE_MODULE_CLE_SUCCESS = "UPDATE_MODULE_CLE_SUCCESS";
export const UPDATE_MODULE_CLE_FAIL = "UPDATE_MODULE_CLE_FAIL";

export const DELETE_MODULE_CLE_REQUEST = "DELETE_MODULE_CLE_REQUEST";
export const DELETE_MODULE_CLE_SUCCESS = "DELETE_MODULE_CLE_SUCCESS";
export const DELETE_MODULE_CLE_FAIL = "DELETE_MODULE_CLE_FAIL";

export const setModulesCleLoading = (v) => ({ type: SET_MODULES_CLE_LOADING, payload: v });
export const setModulesCleError = (msg) => ({ type: SET_MODULES_CLE_ERROR, payload: msg });

export const fetchModulesCleRequest = () => ({ type: FETCH_MODULES_CLE_REQUEST });
export const fetchModulesCleSuccess = (data) => ({ type: FETCH_MODULES_CLE_SUCCESS, payload: data });
export const fetchModulesCleFail = (err) => ({ type: FETCH_MODULES_CLE_FAIL, payload: err });

export const createModuleCleRequest = (payload) => ({ type: CREATE_MODULE_CLE_REQUEST, payload });
export const createModuleCleSuccess = (data) => ({ type: CREATE_MODULE_CLE_SUCCESS, payload: data });
export const createModuleCleFail = (err) => ({ type: CREATE_MODULE_CLE_FAIL, payload: err });

export const updateModuleCleRequest = (id, payload) => ({
    type: UPDATE_MODULE_CLE_REQUEST,
    payload: { id, payload },
});
export const updateModuleCleSuccess = (data) => ({ type: UPDATE_MODULE_CLE_SUCCESS, payload: data });
export const updateModuleCleFail = (err) => ({ type: UPDATE_MODULE_CLE_FAIL, payload: err });

export const deleteModuleCleRequest = (id) => ({ type: DELETE_MODULE_CLE_REQUEST, payload: { id } });
export const deleteModuleCleSuccess = (id) => ({ type: DELETE_MODULE_CLE_SUCCESS, payload: id });
export const deleteModuleCleFail = (err) => ({ type: DELETE_MODULE_CLE_FAIL, payload: err });
